const translations = {
    'settlement.city': 'City: %s',
    'settlement.defaultName': 'First Settlement',
    'settlement.population': 'Population: %d/%d (free %d)',
    'settlement.tier': 'Tier: %s',
    'settlement.title': 'City Details',
    'population.section.food': 'Food',
    'population.section.heat': 'Heat',
    'population.food.target': 'House target: %d h',
    'population.food.setTarget': 'Set house food target',
    'population.food.reserve': 'Reserve: %s',
    'population.heat.balance': 'Fuel balance: %s heat/h',
    'population.heat.target': 'House target: %d h',
    'population.heat.setTarget': 'Set house heat target',
    'population.heat.reserve': 'Fuel reserve: %s',
    'population.heat.coldRate': 'Cold debt rate: %s',
    'population.heat.freeze': 'Freeze in: %s',
    'population.heat.units': '%.1f heat',
    'population.heat.unitsPerHour': '%.1f heat/h',
    'population.hours': '%.1f h',
    'population.stable': 'Stable',
    'population.unknown': 'Insufficient data',
    'population.house.title': 'House %d',
    'population.houses.title': 'Houses',
    'population.houses.hint': 'Click a house tile to inspect its people.',
    'population.houses.selectHint': 'Select a house above to see people details.',
    'population.house.occupants': 'Occupants: %d',
    'population.house.warmth': 'Warmth: %s',
    'population.house.food': 'Food: %s',
    'population.house.wood': 'Wood: %s',
    'population.house.charcoal': 'Charcoal: %s',
    'population.people.title': 'House %d occupants',
    'population.people.title.none': 'House occupants',
    'population.people.empty': 'No people assigned.',
    'population.people.job': 'Job: %s',
    'population.people.hunger': 'Hunger debt: %d/%d',
    'population.people.warmth': 'Warmth: %d/%d',
};

export default translations;
